const initialState = {
    build: null,
    deploy: null
};

export default function app(state = initialState, action = {}) {
    let newState = Object.assign({}, state);

    if (action.type === 'SET_APP_INFO') {
        const { deploy, build } = action.data;
        newState = {
            deploy,
            build
        };
    }

    return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/app.js